
import React, { useEffect, useState } from "react";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend
);

const QualityTrendChart = () => {
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState(null);
  const fetchQuality = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/quality_metrics`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        const api = result.data;
        const months = Object.keys(api.first_pass);
        const formattedData = {
          labels: months,
          datasets: [
            {
              label: "First Pass Yield %",
              data: months.map((first) => {
                const value = api.first_pass[first]?.total_ncs ?? 0;
                return value;
              }),
              borderColor: "#0a28a3",
              backgroundColor: "#0a28a3",
              tension: 0.3,
              pointStyle: "circle",
              pointRadius: 5,
              fill: false,
            },
            {
              label: "Rework %",
              data: months.map((work) => {
                const value = api.rework[work]?.total_ncs ?? 0;
                return value;
              }),
              borderColor: "#f0a200",
              backgroundColor: "#f0a200",
              tension: 0.3,
              pointStyle: "circle",
              pointRadius: 5,
              fill: false,
            },
            {
              label: "Scrap %",
              data: months.map((scrap) => {
                const value = api.scrap[scrap]?.total_ncs ?? 0;
                return value;
              }),
              borderColor: "#f44336",
              backgroundColor: "#f44336",
              tension: 0.3,
              pointStyle: "circle",
              pointRadius: 5,
              fill: false,
            },
          ],
        };

        setChartData(formattedData);
      }
    } catch (err) {
      console.error("Error fetching quality metrics:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuality();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: { usePointStyle: true },
      },
      title: {
        display: true,
        text: "Quality Metrics Trend",
        font: { size: 18, weight: "bold" },
        align: "start",
        padding: { bottom: 20 },
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        title: { display: true, text: "%" },
      },
    },
  };

  return (
    <div className="card p-3 shadow-sm">
      {loading ? (
        <Loader />
      ) : (
        <div style={{ height: "300px" }}>
          {chartData && <Line data={chartData} options={options} />}
        </div>
      )}
    </div>
  );
};

export default QualityTrendChart;
